export default {
  draft: "draft",
  partiallySigned: "partially-signed",
  signed: "signed",
  unsigned: "unsigned"
};
